module.exports = __webpack_public_path__ + "static/img/230.311eb654.png";